import { DocumentNames } from '../../constants/templateDictionaries';
import getOrganization from './getOrganization';
import getSkills from './getSkills';
import getInput from './getInput';
import getEditableDiv from './getEditableDiv';
import getDefaultResumeUserPreferences from './getDefaultResumeUserPreferences';

let isSmallScreen;
if (typeof window !== `undefined`) {
  isSmallScreen = window.screen.width < 1280;
}

export default ({ selectedPlan = null, universityPlan = null }) => ({
  templateType: DocumentNames.RESUME,
  permissions: null,
  userId: null,
  documentName: 'Untitled Resume',
  status: 0,
  resumeType: 'Attractive',
  eventTypes: [],
  removeOnNextLoad: {
    comments: [],
  },
  editedInputs: [],
  linkedInOptimizerEditedInputs: [],
  questionsGeneratorEditedInputs: [],
  fileImported: false,
  isFileImporting: false,
  isStreamFinished: false,
  userPreferences: getDefaultResumeUserPreferences({
    isSmallScreen,
    selectedPlan,
    universityPlan,
  }),
  fullName: getInput({ preTag: 'full_name', componentKey: 'fullName' }),
  email: getInput({ preTag: 'email', componentKey: 'email' }),
  tagline: getInput({ preTag: 'tagline', componentKey: 'tagline' }),
  phoneNumber: getInput({
    preTag: 'phone_number',
    componentKey: 'phoneNumber',
  }),
  address: getInput({ preTag: 'address', componentKey: 'address' }),
  objective: getEditableDiv({ preTag: 'objective', componentKey: 'objective' }),
  personalLinks: getSkills({
    preTag: 'personal_link',
    componentKey: 'personalLinks',
  }),
  summary: getEditableDiv({ preTag: 'summary', componentKey: 'summary' }),

  workExperience: getOrganization({
    preTag: 'work_experience',
    sectionKey: 'workExperience',
    universityPlan,
  }),
  education: getOrganization({
    preTag: 'education',
    sectionKey: 'education',
    universityPlan,
  }),
  skills: getOrganization({ preTag: 'skill', sectionKey: 'skills' }),
  awardsAndHonors: getOrganization({
    preTag: 'awards_and_honors',
    sectionKey: 'awardsAndHonors',
  }),
  volunteerWork: getOrganization({
    preTag: 'volunteer_work',
    sectionKey: 'volunteerWork',
    universityPlan,
  }),
  certifications: getOrganization({
    preTag: 'certifications',
    sectionKey: 'certifications',
  }),
  projects: getOrganization({ preTag: 'projects', sectionKey: 'projects' }),
  researchExperience: getOrganization({
    preTag: 'research_experience',
    sectionKey: 'researchExperience',
  }),
  leadership: getOrganization({
    preTag: 'leadership',
    sectionKey: 'leadership',
  }),
  associations: getOrganization({
    preTag: 'associations',
    sectionKey: 'associations',
  }),
  extraCurricular: getOrganization({
    preTag: 'extra_curricular',
    sectionKey: 'extraCurricular',
  }),
  languages: getSkills({ preTag: 'language', sectionKey: 'languages' }),
  hobbiesAndInterests: getSkills({
    preTag: 'hobbies_and_interests',
    sectionKey: 'hobbiesAndInterests',
  }),
  conferences: getOrganization({
    preTag: 'conferences',
    sectionKey: 'conferences',
  }),
  publications: getSkills({
    preTag: 'publication',
    sectionKey: 'publications',
  }),
  courses: getOrganization({
    preTag: 'courses',
    sectionKey: 'courses',
  }),
  references: getOrganization({
    preTag: 'references',
    sectionKey: 'references',
  }),
  patents: getOrganization({
    preTag: 'patents',
    sectionKey: 'patents',
  }),
  testScores: getOrganization({
    preTag: 'test_scores',
    sectionKey: 'testScores',
  }),
});
